import { COLORS } from "./constant";

const functions = {
  firstLetterToUpperCase: (word) => {
    return word?.length > 0 && word[0]?.toUpperCase() + word.slice(1);
  },
  firstLetterOnlyToUpperCase: (word) => {
    return (
      word?.length > 0 && word[0]?.toUpperCase() + word.slice(1).toLowerCase()
    );
  },
  firstLettersToUpperCase: (sentence) => {
    return sentence
      ?.split(" ")
      ?.map((word) => word[0]?.toUpperCase() + word.slice(1).toLowerCase())
      ?.join(" ");
  },
  toLowerCase: (word) => word && word?.toLowerCase(),
  toUpperCase: (word) => word && word?.toUpperCase(),
  splitAndFirstLetterToUpperCase: (word, spliter) => {
    word = word ? word?.split(spliter)[1] : "";
    return word[0].toUpperCase() + word?.slice(1).toLowerCase();
  },
  splitAndFirstLetterOnlyToUpperCase: (word, spliter) => {
    // word = word ? word?.split(spliter)[1] : "";
    // return word && word[0] ? word[0]?.toUpperCase() + word?.slice(1) : word;
    return word
      .toLowerCase()
      .split(spliter)
      .map((subword) => subword.charAt(0).toUpperCase() + subword.slice(1))
      .join(" ");
  },
  formatDate: {
    toLocaleDateString: (date) => {
      return new Date(date).toLocaleDateString("en", {
        year: "numeric",
        month: "long",
        day: "numeric",
      });
    },
    toLocaleString: (date) => {
      return new Date(date).toLocaleDateString("en", {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
      });
    },
  },

  sortByProperty: (array, property, order = "asc") => {
    if (!Array.isArray(array)) return;

    return array.sort((a, b) => {
      const valueA = a[property];
      const valueB = b[property];

      if (order === "asc") {
        return valueA < valueB ? -1 : valueA > valueB ? 1 : 0;
      } else {
        return valueA > valueB ? -1 : valueA < valueB ? 1 : 0;
      }
    });
  },

  getColorPalette: (key) => {
    if (!designationColorMap.has(key)) {
      designationColorMap.set(
        key,
        COLORS[designationColorMap.size % COLORS.length]
      );
    }
    return designationColorMap.get(key);
  },
};

const designationColorMap = new Map();

const Utils = functions;

export default Utils;
